export const ADMIN = 'Admin';
export const MANAGER = 'Manager';
export const CANDIDATE = 'Candidate';
